module.exports = __webpack_public_path__ + "resources\\localization\\pt-br.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/pt-br.json
 ** module id = 34
 ** module chunks = 0
 **/